import React from 'react';
import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import {
  Calendar,
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
  OutlinedIcons,
} from '@marageti/z4-lib';
import CapacityCard from '../../../../components/partner/capacity-card';
import EditCapacityContainer from '../../../../components/partner/edit-capacity-form';
import { ViewProps } from './types';
import './styles.scss';
import EventCard from '../../../../components/partner/event-card';

const {
  OutlinedCalendarIcon,
} = OutlinedIcons;

const AvailabilityView = ({
  editorOpen,
  error,
  onCloseEditor,
  partnerAvailability,
  partnerAvailabilityList = [],
  capacity,
  leadLimit,
  fetchHistoricAvailabilityData,
  canEditCapacity,
  contextMenuProps,
  handleActiveDateChange,
  activeDate,
}: ViewProps) => {
  const theme = useTheme();
  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          py: 3,
          width: { desktop: '662px' },
          margin: { desktop: '0 auto 56px' },
        }}
      >
        <Typography variant="h2" sx={{ mb: 3 }}>Availability & Capacity</Typography>
        <Stack>
          <Box>
            {error ? (
              <ErrorBox>
                <ErrorTitle>
                  There was an error getting partner leads max
                </ErrorTitle>
                <ErrorMessage>
                  {`Code: ${error.code}: ${error.message}`}
                </ErrorMessage>
              </ErrorBox>
            ) : (
              <Stack
                spacing={{ desktop: 2, mobile: 2 }}
                direction={{ desktop: 'row', mobile: 'column' }}
                mb={{ desktop: '56px', mobile: '24px' }}
              >
                <CapacityCard
                  title="Current Capacity"
                  value={leadLimit}
                  toolTipText="Maximum capacity set by availability"
                />
                <CapacityCard
                  title="Max Capacity"
                  value={capacity}
                  canEditCapacity={canEditCapacity}
                  contextMenuProps={contextMenuProps}
                  toolTipText="Maximum capacity set by Zicasso"
                />

              </Stack>
            )}
          </Box>
          <Box className="calendar" display="flex" justifyContent="center" alignItems="center">
            <Calendar availabilityData={partnerAvailability || []} handlePrevButton={fetchHistoricAvailabilityData} onActiveDateChange={handleActiveDateChange} />
          </Box>
          {partnerAvailabilityList?.length !== 0 ? (
            <Box sx={{ mt: { desktop: '56px', mobile: '26px' } }}>
              <Typography variant="h4" sx={{ mb: 1 }}>{`Events for ${activeDate.toLocaleString('default', { month: 'long' })}`}</Typography>
              {partnerAvailabilityList && partnerAvailabilityList.map((listItem) => (
                <EventCard key={listItem.limitType + listItem.startDate + listItem.endDate} availabilityItem={listItem} capacity={capacity} />
              ))}
            </Box>
          ) : (
            <Box sx={{ pt: '48px', pb: '56px' }}>
              <Stack justifyContent="center" alignContent="center" alignItems="center">
                <OutlinedCalendarIcon sx={{
                  color: theme.palette.common.black50, width: '48px', height: '48px', strokeWeight: '1px !important',
                }}
                />
                <Typography variant="body" sx={{ mb: 1, color: theme.palette.common.black75 }}>There are no events for this month</Typography>
              </Stack>
            </Box>

          )}
        </Stack>
        <EditCapacityContainer open={editorOpen} onClose={onCloseEditor} />
      </Box>
    </Container>
  );
};

export default AvailabilityView;
